/**
 * Damm-Prüfziffer (Quasigruppe der Ordnung 10).
 *
 * Erkennt alle Einzelfehler und alle Vertauschungen benachbarter Ziffern (mit jedem Startwert).
 * Ein Startwert (0–9) verändert die Prüfziffer: Ein Code, der für Startwert a gültig ist, ist für
 * jeden anderen Startwert immer ungültig. Da es nur zehn Startwerte gibt, teilen sich zwei
 * zufällig zugeteilte Organisationen mit etwa 10 % Wahrscheinlichkeit denselben Startwert.
 */
const DAMM_TABLE: readonly (readonly number[])[] = [
  [0, 3, 1, 7, 5, 9, 8, 6, 4, 2],
  [7, 0, 9, 2, 1, 5, 4, 8, 6, 3],
  [4, 2, 0, 6, 8, 7, 1, 3, 5, 9],
  [1, 7, 5, 0, 9, 8, 3, 4, 2, 6],
  [6, 1, 2, 3, 0, 4, 5, 9, 7, 8],
  [3, 6, 7, 4, 2, 0, 9, 5, 8, 1],
  [5, 8, 6, 9, 7, 2, 0, 1, 3, 4],
  [8, 9, 4, 5, 3, 6, 2, 0, 1, 7],
  [9, 4, 3, 8, 6, 1, 7, 2, 0, 5],
  [2, 5, 8, 1, 4, 3, 6, 7, 9, 0],
];

function step(interim: number, digit: number): number {
  const value = DAMM_TABLE[interim]?.[digit];
  if (value === undefined) {
    throw new RangeError(`Ungültige Ziffer im Damm-Verfahren: ${String(digit)}`);
  }
  return value;
}

function assertSalt(salt: number): void {
  if (!Number.isInteger(salt) || salt < 0 || salt > 9) {
    throw new RangeError('Der Startwert (salt) muss eine ganze Zahl von 0 bis 9 sein.');
  }
}

function runDamm(digits: string, salt: number): number {
  assertSalt(salt);
  if (!/^\d+$/.test(digits)) {
    throw new TypeError('Das Damm-Verfahren erwartet nur Ziffern.');
  }
  let interim = salt;
  for (const char of digits) {
    interim = step(interim, char.charCodeAt(0) - 48);
  }
  return interim;
}

/** Berechnet die Prüfziffer (0–9) für eine Ziffernfolge. */
export function dammCheckDigit(digits: string, salt = 0): number {
  return runDamm(digits, salt);
}

/** Prüft eine Ziffernfolge, deren letzte Ziffer die Prüfziffer ist. */
export function isValidDammNumber(digitsWithCheck: string, salt = 0): boolean {
  if (!/^\d{2,}$/.test(digitsWithCheck)) {
    return false;
  }
  return runDamm(digitsWithCheck, salt) === 0;
}
